import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { formatDate, statusClass } from "@/lib/format";
import { ArrowRight } from "lucide-react";

export default function PRDs() {
  const [prds, setPrds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/prds")
      .then((r) => setPrds(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid={TID.prdsPage} className="space-y-4">
      <p className="text-sm text-neutral-400 max-w-2xl">
        PRD (Product Requirement Document) generati dai lead. Obiettivi, scope, milestone.
      </p>

      {err && (
        <div className="border border-red-900/60 bg-red-950/20 px-4 py-3 font-mono text-xs text-red-300">
          {err}
        </div>
      )}

      <div className="border border-[#1F1F1F] bg-[#0C0C0C]">
        <header className="border-b border-[#1F1F1F] px-4 py-3 flex items-center justify-between bg-[#141414]">
          <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-400">prd</span>
          <span className="font-mono text-[10px] text-neutral-600">{prds.length} items</span>
        </header>
        <table data-testid={TID.prdsTable} className="w-full">
          <thead>
            <tr className="border-b border-[#1F1F1F] font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              <th className="text-left px-4 py-2">ID</th>
              <th className="text-left px-4 py-2">Cliente</th>
              <th className="text-left px-4 py-2 hidden md:table-cell">Progetto</th>
              <th className="text-left px-4 py-2">Ver.</th>
              <th className="text-left px-4 py-2">Stato</th>
              <th className="text-left px-4 py-2 hidden lg:table-cell">Data</th>
              <th className="text-right px-4 py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#1F1F1F]">
            {loading && (
              <tr>
                <td colSpan={7} className="px-4 py-6 font-mono text-xs text-neutral-500">
                  <span className="cursor-blink">LOADING</span>
                </td>
              </tr>
            )}
            {!loading && prds.length === 0 && (
              <tr>
                <td colSpan={7} className="px-4 py-6 font-mono text-xs text-neutral-500">
                  Nessun PRD. Genera dal dettaglio lead.
                </td>
              </tr>
            )}
            {prds.map((p) => (
              <tr key={p.id} data-testid={TID.prdRow} className="hover:bg-[#141414]">
                <td className="px-4 py-3 font-mono text-xs text-neutral-300">{p.id}</td>
                <td className="px-4 py-3 text-sm">
                  <Link to={`/app/prds/${p.id}`} className="text-[#EDEDED] underline decoration-neutral-700 hover:decoration-[#EDEDED] underline-offset-2">
                    {p.client_name}
                  </Link>
                </td>
                <td className="px-4 py-3 text-sm text-neutral-400 hidden md:table-cell">
                  {p.project_name}
                </td>
                <td className="px-4 py-3 font-mono text-xs text-neutral-300">v{p.version}</td>
                <td className="px-4 py-3">
                  <span className={`font-mono text-[9px] uppercase tracking-widest border px-1.5 py-0.5 ${statusClass(p.status)}`}>
                    {p.status}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-[11px] text-neutral-500 hidden lg:table-cell">
                  {formatDate(p.created_at)}
                </td>
                <td className="px-4 py-3 text-right">
                  <Link
                    to={`/app/prds/${p.id}`}
                    className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-neutral-400 hover:text-[#EDEDED]"
                  >
                    Apri
                    <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
